import {store} from "../../store";
import routeMapper from "../routeMapper";
import {canAccessPageBasedOnPermission} from "../../helper/AdminBackofficeHelper";

export default {
	routes: [
		// admin routes
		{
			path: "/admin",
			beforeEnter: (to, from, next) => {
				next("/admin/orders");
			}
		},
		{
			path: "/admin/login",
			name: routeMapper.routeNames.adminLogin,
			component: () => import("../../components/Admin/AdminLogin")
		},
		{
			path: "/admin/adLogin",
			name: routeMapper.routeNames.adminADLogin,
			component: () => import("../../components/Admin/AdminADLogin")
		},
		{
			path: "/admin/googleLogin",
			name: routeMapper.routeNames.adminGoogleLogin,
			component: () => import("../../components/Admin/AdminGoogleLogin")
		},
		{
			path: "/admin/orders",
			name: routeMapper.routeNames.adminOrders,
			meta: {
				pagePermission: "ordersPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("ordersPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/OrdersMain") :
					import("../../components/Admin/PermissionDenied");
			},
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			}
		},
		{
			path: "/admin/orders/generateOrders",
			name: routeMapper.routeNames.adminOrderGenerate,
			meta: {
				pagePermission: "orderGeneratePagePermission"
			},
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderGeneratePagePermission", store) ?
					import("../../components/Admin/OrderGenerate/OrderGenerate") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/orders/:orderId",
			name: routeMapper.routeNames.adminSingleOrder,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "singleOrderPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("singleOrderPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/OrdersMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/orders/printOrderPreparation/:orderId",
			name: routeMapper.routeNames.printOrderPreparation,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printOrderPreparationPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printOrderPreparationPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderPreparationPrint") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const orderId = route.params.orderId;
				return {
					orderId: orderId
				};
			}
		},
		{
			path: "/admin/orders/printOrderPreparationDay/:pickupDate",
			name: routeMapper.routeNames.printOrderPreparationDay,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printOrderPreparationDayPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printOrderPreparationDayPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderPreparationDayPrint") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const pickupDate = route.params.pickupDate;
				const autoPrintDialog = route.params.autoPrintDialog;
				const departmentFilter = route.params.departmentFilter;
				return {
					pickupDate: pickupDate,
					autoPrintDialog: autoPrintDialog,
					departmentFilter: departmentFilter
				};
			}
		},
		{
			path: "/admin/orders/printOrderReceipt/orderId/:orderId",
			name: routeMapper.routeNames.printOrderReceipt,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printOrderReceiptPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printOrderReceiptPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderReceiptPrint") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const orderId = route.params.orderId;
				return {
					orderId: orderId
				};
			}
		},
		{
			path: "/admin/orders/printAllSingleOrder/orderId/:orderId",
			name: routeMapper.routeNames.printAllSingleOrder,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printAllSingleOrderPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printAllSingleOrderPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderPrintAllSingleOrderWrapper") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const orderId = route.params.orderId;
				return {
					orderId: orderId
				};
			}
		},
		{
			path: "/admin/orders/printOrderReceipt/pickupDate/:pickupDate",
			name: routeMapper.routeNames.printAllOrdersReceiptForDate,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printAllOrdersReceiptForDatePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printAllOrdersReceiptForDatePagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderReceiptPrint") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const pickupDate = route.params.pickupDate;
				const departmentFilter = route.params.departmentFilter;
				const paymentStatusFilter = route.params.paymentStatusFilter;
				return {
					pickupDate: pickupDate,
					departmentFilter: departmentFilter,
					paymentStatusFilter
				};
			}
		},
		{
			path: "/admin/orders/printAllDayOrders/pickupDate/:pickupDate",
			name: routeMapper.routeNames.printAllOrdersForDate,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printAllOrdersForDatePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printAllOrdersForDatePagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderPrintAllDayOrdersWrapper") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const pickupDate = route.params.pickupDate;
				const departmentFilter = route.params.departmentFilter;
				return {
					pickupDate: pickupDate,
					departmentFilter: departmentFilter
				};
			}
		},
		{
			path: "/admin/orders/printAllOrdersForToday/pickupDate/:pickupDate",
			name: routeMapper.routeNames.printAllOrdersForToday,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "printAllOrdersForTodayPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("printAllOrdersForTodayPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/PrintDialogs/OrderPrintToday") :
					import("../../components/Admin/PermissionDenied");
			},
			props(route) {
				const pickupDate = route.params.pickupDate;
				const autoPrintDialog = route.params.autoPrintDialog;
				return {
					pickupDate: pickupDate,
					autoPrintDialog: autoPrintDialog
				};
			}
		},
		{
			path: "/admin/newOrder",
			name: routeMapper.routeNames.adminNewOrder,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "newOrderPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("newOrderPagePermission", store) ?
					import("../../components/Admin/OrderForm/OrderFormMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/settings/",
			name: routeMapper.routeNames.adminSettings,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "settingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("settingsPagePermission", store) ?
					import("../../components/Admin/Settings/SettingsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/shopSettings/",
			name: routeMapper.routeNames.adminShopSettings,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "shopSettingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("shopSettingsPagePermission", store) ?
					import("../../components/Admin/Settings/ShopSettings") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/featureToggle/",
			name: routeMapper.routeNames.adminFeatureTogglePage,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "featureTogglePagePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("featureTogglePagePagePermission", store) ?
					import("../../components/Admin/ShopsSettings/FeatureTogglePage") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/tenantSettings/",
			name: routeMapper.routeNames.adminTenantSettings,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "tenantSettingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("tenantSettingsPagePermission", store) ?
					import("../../components/Admin/TenantSettings/TenantSettingsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/operations/",
			name: routeMapper.routeNames.adminOperations,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "operationsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("operationsPagePermission", store) ?
					import("../../components/Admin/Operations/OperationsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/products/",
			name: routeMapper.routeNames.adminProducts,
			children: [
				{
					name: routeMapper.routeNames.adminProductOverview,
					path: ":productId",
					meta: {
						pagePermission: "productOverviewPagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("productOverviewPagePermission", store) ?
							import("../../components/Admin/Products/ProductForm") :
							import("../../components/Admin/PermissionDenied");
					}
				},
				{
					name: routeMapper.routeNames.adminProductCreate,
					path: "create",
					meta: {
						pagePermission: "productCreatePagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("productCreatePagePermission", store) ?
							import("../../components/Admin/Products/ProductForm") :
							import("../../components/Admin/PermissionDenied");
					}
				}
			],
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productsPagePermission", store) ?
					import("../../components/Admin/Products/ProductsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/ingredients/",
			name: routeMapper.routeNames.adminIngredients,
			children: [
				{
					name: routeMapper.routeNames.adminCreateIngredientOverview,
					path: "create",
					meta: {
						pagePermission: "createIngredientOverviewPagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("createIngredientOverviewPagePermission", store) ?
							import("../../components/Admin/Ingredients/CreateIngredientOverview") :
							import("../../components/Admin/PermissionDenied");
					}
				},
				{
					name: routeMapper.routeNames.adminIngredientsOverview,
					path: ":ingredientId",
					meta: {
						pagePermission: "ingredientsOverviewPagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("ingredientsOverviewPagePermission", store) ?
							import("../../components/Admin/Ingredients/IngredientsOverview") :
							import("../../components/Admin/PermissionDenied");
					}
				}
			],
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "ingredientsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("ingredientsPagePermission", store) ?
					import("../../components/Admin/Ingredients/IngredientsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productsIngredients/",
			name: routeMapper.routeNames.adminProductsIngredients,
			children: [
				{
					name: routeMapper.routeNames.adminCreateProductIngredients,
					path: "create",
					meta: {
						pagePermission: "createProductIngredientsPagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("createProductIngredientsPagePermission", store) ?
							import("../../components/Admin/Ingredients/ProductsIngredients/AddIngredient") :
							import("../../components/Admin/PermissionDenied");
					}
				},
				{
					name: routeMapper.routeNames.adminProductIngredientsOverview,
					path: ":productId",
					meta: {
						pagePermission: "productIngredientsOverviewPagePermission"
					},
					component: () => {
						return canAccessPageBasedOnPermission("productIngredientsOverviewPagePermission", store) ?
							import("../../components/Admin/Ingredients/ProductsIngredients/ProductsIngredientsForm") :
							import("../../components/Admin/PermissionDenied");
					}
				}
			],
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productsIngredientsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productsIngredientsPagePermission", store) ?
					import("../../components/Admin/Ingredients/ProductsIngredients/ProductsIngredientsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/catalogPages/",
			name: routeMapper.routeNames.adminCatalogPages,
			children: [{
				name: routeMapper.routeNames.adminCatalogPagesOverview,
				path: ":catalogId",
				meta: {
					pagePermission: "catalogPagesOverviewPagePermission"
				},
				component: () => {
					return canAccessPageBasedOnPermission("catalogPagesOverviewPagePermission", store) ?
						import("../../components/Admin/Catalogs/CatalogForm") :
						import("../../components/Admin/PermissionDenied");
				}
			}],
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "catalogPagesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("catalogPagesPagePermission", store) ?
					import("../../components/Admin/Catalogs/CatalogsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/catalogPagesUI/",
			name: routeMapper.routeNames.adminCatalogPagesUI,
			children: [{
				name: routeMapper.routeNames.adminCatalogPagesUIOverview,
				path: ":catalogId",
				meta: {
					pagePermission: "catalogPagesUIOverviewPagePermission"
				},
				component: () => {
					return canAccessPageBasedOnPermission("catalogPagesUIOverviewPagePermission", store) ?
						import("../../components/Admin/Catalogs/CatalogsUI/CatalogProducts") :
						import("../../components/Admin/PermissionDenied");
				}
			}],
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "catalogPagesUIPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("catalogPagesUIPagePermission", store) ?
					import("../../components/Admin/Catalogs/CatalogsUI/CatalogsMainUIWrapper") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/demodata/",
			name: routeMapper.routeNames.adminDemoData,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "demoDataPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("demoDataPagePermission", store) ?
					import("../../components/Admin/Prototype/DemoData") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/orderstatistics2/",
			name: routeMapper.routeNames.adminOrderStatistics,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "orderStatisticsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderStatisticsPagePermission", store) ?
					import("../../components/Admin/OrdersOverview/OrderStatistics") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productstatistics/",
			name: routeMapper.routeNames.adminProductStatistics,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productStatisticsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productStatisticsPagePermission", store) ?
					import("../../components/Admin/ProductsOverview/ProductStatistics") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/shopOptions",
			name: routeMapper.routeNames.adminShopOptions,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "shopOptionsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("shopOptionsPagePermission", store) ?
					import("../../components/Admin/ShopOptions/ShopOptions") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/prototype/vikingOrder",
			name: routeMapper.routeNames.adminPrototypeVikingOrder,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "prototypeVikingOrderPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("prototypeVikingOrderPagePermission", store) ?
					import("../../components/Admin/Prototype/VikingOrderPrototype") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/export",
			name: routeMapper.routeNames.adminExport,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "exportPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("exportPagePermission", store) ?
					import("../../components/Admin/Export/Export") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productCounterOverview",
			name: routeMapper.routeNames.productCounterOverview,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productCounterOverviewPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productCounterOverviewPagePermission", store) ?
					import("../../components/Admin/ProductCounter/ProductCounterOverview") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productMonitoring",
			name: routeMapper.routeNames.productMonitoring,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productMonitoringPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productMonitoringPagePermission", store) ?
					import("../../components/Admin/ProductMonitoring/ProductMonitoring") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productMonitoring2",
			name: routeMapper.routeNames.productMonitoring2,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productMonitoring2PagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productMonitoring2PagePermission", store) ?
					import("../../components/Admin/ProductMonitoring2/ProductMonitoring") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productMonitoring3",
			name: routeMapper.routeNames.productMonitoring3,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productMonitoring3PagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productMonitoring3PagePermission", store) ?
					import("../../components/Admin/ProductMonitoring3/ProductMonitoring") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productMonitoring4",
			name: routeMapper.routeNames.productMonitoring4,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productMonitoring4PagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productMonitoring4PagePermission", store) ?
					import("../../components/Admin/ProductMonitoring4/ProductMonitoring") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/orderMonitoring",
			name: routeMapper.routeNames.orderMonitoring,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "orderMonitoringPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderMonitoringPagePermission", store) ?
					import("../../components/Admin/OrderMonitoring/OrderMonitoring") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/prototype/payments",
			name: routeMapper.routeNames.adminPrototypePayments,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "prototypePaymentsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("prototypePaymentsPagePermission", store) ?
					import("../../components/Admin/Prototype/PrototypePayment") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/devsupport",
			name: routeMapper.routeNames.adminDevSupport,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "devSupportPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("devSupportPagePermission", store) ?
					import("../../components/Admin/Prototype/SettingsPrototype") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/pickupRules",
			name: routeMapper.routeNames.adminPickupDateTimeRules,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "pickupDateTimeRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("pickupDateTimeRulesPagePermission", store) ?
					import("../../components/Admin/PickupDateTimeRules/PickupDateTimeRulesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/priceRules",
			name: routeMapper.routeNames.adminPriceRules,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "priceRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("priceRulesPagePermission", store) ?
					import("../../components/Admin/PriceRules/PriceRulesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/marketingCards",
			name: routeMapper.routeNames.adminMarketingCards,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "marketingCardsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("marketingCardsPagePermission", store) ?
					import("../../components/Admin/MarketingCards/MarketingCardsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/targetGroups",
			name: routeMapper.routeNames.adminTargetingGroups,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "targetingGroupsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("targetingGroupsPagePermission", store) ?
					import("../../components/Admin/TargetingGroups/TargetingGroupsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/punchCardRules",
			name: routeMapper.routeNames.adminPunchCardRules,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "punchCardRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("punchCardRulesPagePermission", store) ?
					import("../../components/Admin/PunchCardRules/PunchCardRulesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/pickupRules/:ruleId",
			name: routeMapper.routeNames.adminPickupRulesSingle,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "pickupRulesSinglePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("pickupRulesSinglePagePermission", store) ?
					import("../../components/Admin/CapacityRules/steps/CapacityRulesShopSelection") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/voucherRules",
			name: routeMapper.routeNames.adminVouchers,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "vouchersPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("vouchersPagePermission", store) ?
					import("../../components/Admin/Vouchers/VouchersMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/capacityPrototype",
			name: routeMapper.routeNames.adminCapacityRulesPrototype,
			meta: {
				pagePermission: "capacityRulesPrototypePagePermission"
			},
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			component: () => {
				return canAccessPageBasedOnPermission("capacityRulesPrototypePagePermission", store) ?
					import("../../components/Admin/CapacityRulesPrototype/CapacityRulesPrototypeMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/capacityRulesNew",
			name: routeMapper.routeNames.adminCapacityRules,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "capacityRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("capacityRulesPagePermission", store) ?
					import("../../components/Admin/CapacityRules/CapacityRulesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/ordercontrolpanel/",
			name: routeMapper.routeNames.adminOrderControlPanel,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "orderControlPanelPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderControlPanelPagePermission", store) ?
					import("../../components/Admin/OrderControlPanel/OrderControlPanel") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/shops",
			name: routeMapper.routeNames.adminShopsSettings,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "shopsSettingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("shopsSettingsPagePermission", store) ?
					import("../../components/Admin/ShopsSettings/ShopsSettingsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/timePicker",
			name: routeMapper.routeNames.adminTimePicker,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "timePickerPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("timePickerPagePermission", store) ?
					import("../../components/Admin/TimePicker/TimePickerMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/shopInfo",
			name: routeMapper.routeNames.adminShopInfo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "shopInfoPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("shopInfoPagePermission", store) ?
					import("../../components/Admin/ShopInfo/ShopInfoMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/localizationSettings",
			name: routeMapper.routeNames.adminLocalizationSettings,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "localizationSettingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("localizationSettingsPagePermission", store) ?
					import("../../components/Admin/Localization/LocalizationSettingsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/enrichedCatalog",
			name: routeMapper.routeNames.adminEnrichedProductCatalogs,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "enrichedProductCatalogsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("enrichedProductCatalogsPagePermission", store) ?
					import("../../components/Admin/EnrichedProductCatalogs/EnrichedProductCatalogsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/synchronizations",
			name: routeMapper.routeNames.adminSynchronizations,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "synchronizationsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("synchronizationsPagePermission", store) ?
					import("../../components/Admin/Synchronizations/SynchronizationsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/subscriptionsFraudProtection",
			name: routeMapper.routeNames.SubscriptionsFraudProtection,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "subscriptionsFraudProtectionPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("subscriptionsFraudProtectionPagePermission", store) ?
					import("../../components/Admin/FraudProtection/SubscriptionsFraudProtectionMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/crossSellRules",
			name: routeMapper.routeNames.adminUpsellRules,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "crossSellRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("crossSellRulesPagePermission", store) ?
					import("../../components/Admin/UpsellRules/UpsellRulesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/termsAndConditions",
			name: routeMapper.routeNames.termsAndConditions,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "termsAndConditionsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("termsAndConditionsPagePermission", store) ?
					import("../../components/Admin/TermsAndConditions/TermsAndConditionsMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/s3Cloud",
			name: routeMapper.routeNames.S3Cloud,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "s3CloudPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("s3CloudPagePermission", store) ?
					import("../../components/Admin/Cloud/S3CloudMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/productBadges",
			name: routeMapper.routeNames.ProductBadges,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productBadgesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productBadgesPagePermission", store) ?
					import("../../components/Admin/ProductBadges/ProductBadgesMain") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/globalVersions",
			props: { url: "/admin/products/global-version" },
			name: routeMapper.routeNames.globalVersionsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "globalVersionsGboPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("globalVersionsGboPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/scheduledTasksManager",
			name: routeMapper.routeNames.scheduledTasksManager,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "scheduledTasksManagerPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("scheduledTasksManagerPagePermission", store) ?
					import("../../components/Admin/ScheduledTasksManager/ScheduledTasksManager") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/auditLog",
			name: routeMapper.routeNames.auditLogGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "auditLogGboPagePermission"
			},
			props: { url: "/admin/statistics/audit-log" },
			component: () => {
				return canAccessPageBasedOnPermission("auditLogGboPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/productAvailability",
			props: { url: "/admin/availability/product-availability" },
			name: routeMapper.routeNames.productAvailabilityGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productAvailabilityReactPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productAvailabilityReactPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/productGroups",
			props: { url: "/admin/products/product-groups" },
			name: routeMapper.routeNames.productGroupsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "productCreatePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("productCreatePagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/adminUsers",
			props: { url: "/admin/users/admin-users" },
			name: routeMapper.routeNames.adminUsersGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "adminUsersReactPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("adminUsersReactPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/voucherRules",
			props: { url: "/admin/rules/vouchers" },
			name: routeMapper.routeNames.voucherRulesGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "vouchersPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("vouchersPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/crossSellRules",
			props: { url: "/admin/rules/cross-sells" },
			name: routeMapper.routeNames.crossSellRulesGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "crossSellRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("crossSellRulesPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/priceRules",
			props: { url: "/admin/rules/prices" },
			name: routeMapper.routeNames.priceRulesGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "priceRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("priceRulesPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/capacityPrototype",
			props: { url: "/admin/rules/capacity-prototypes" },
			name: routeMapper.routeNames.capacityPrototypeGbo,
			meta: {
				pagePermission: "capacityRulesPrototypePagePermission"
			},
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			component: () => {
				return canAccessPageBasedOnPermission("capacityRulesPrototypePagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/pickupRules",
			props: { url: "/admin/rules/availability" },
			name: routeMapper.routeNames.pickupRulesGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "pickupDateTimeRulesPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("pickupDateTimeRulesPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/termsAndConditions",
			props: { url: "/admin/rules/terms-and-conditions" },
			name: routeMapper.routeNames.termsAndConditionsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "termsAndConditionsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("termsAndConditionsPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/shopSettings",
			props: { url: "/admin/shops/shop-settings" },
			name: routeMapper.routeNames.shopSettingsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "shopSettingsReactPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("shopSettingsReactPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/statistics",
			props: { url: "/admin/statistics/main" },
			name: routeMapper.routeNames.statisticsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "orderStatisticsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderStatisticsPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/orderControlPanel",
			props: { url: "/admin/control/order-control-panel" },
			name: routeMapper.routeNames.orderControlPanelGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "orderControlPanelPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("orderControlPanelPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/featureToggle",
			props: { url: "/admin/control/feature-toggles" },
			name: routeMapper.routeNames.featureToggleGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "featureTogglePagePagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("featureTogglePagePagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		},
		{
			path: "/admin/gbo/tenantSettings",
			props: { url: "/admin/control/tenant-settings" },
			name: routeMapper.routeNames.tenantSettingsGbo,
			beforeEnter: (to, from, next) => {
				store.dispatch("cacheAdminDetails").then(next);
			},
			meta: {
				pagePermission: "tenantSettingsPagePermission"
			},
			component: () => {
				return canAccessPageBasedOnPermission("tenantSettingsPagePermission", store) ?
					import("../../components/Admin/VueToGbo") :
					import("../../components/Admin/PermissionDenied");
			}
		}
	]
};
